import React from 'react'
import TableHeader from './table-header'
import TableData from './table-data'
import Loader from 'components/loader'

function Table({ headers = [], data = [], loading, sortable, sort, onSort }) {
  return loading ? (
    <Loader />
  ) : (
    <div>
      <TableHeader
        headers={headers}
        sortable={sortable}
        sort={sort}
        onSort={onSort}
      />
      <TableData data={data} headers={headers} />
    </div>
  )
}

export default Table
